import { useState, useEffect } from "react";
import axios from "axios";
import PasosContainer from "../components/PasosContainer";
import { useAuthContext } from "../hooks/useAuthContext";
import { useConfig } from "../hooks/useConfig";
import Tabla from "../components/Tabla";

const PreparandoEncuesta = () => {
  const { user } = useAuthContext();
  const { anio, cuat } = useConfig();
  const [loading, setLoading, configsLoading] = useState(true);
  const [horarios, setHorarios] = useState([]);
  const [envio, setEnvio] = useState(null);
  const [conservar, setConservar] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const reqHeader = {
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  };
  useEffect(() => {
    const fetchHorarios = async () => {
      setLoading(true);
      try {
        const h = await axios.get(
          `/api/docentes/conservar/${anio}/${cuat}`,
          reqHeader,
        );
        const r = await axios.get(
          `/api/docentes/enviar/${anio}/${cuat}`,
          reqHeader,
        );
        setHorarios(h?.data?.horarios ?? []);
        if (r?.data ?? false) {
          setEnvio(true);
          setConservar(r?.data?.conservar);
        } else {
          setEnvio(false);
        }
      } catch (error) {
        console.error("Error fetching horarios:", error);
      } finally {
        setLoading(false);
      }
    };
    if (!configsLoading) {
      fetchHorarios();
    }
  }, [configsLoading, anio, cuat, disabled]);

  const handleConservar = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      const cons = {
        anio,
        cuat,
        docente: user.dni,
      };
      await axios.post(`/api/docentes/conservar/${anio}/${cuat}`, cons, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
    } catch (error) {
      console.error("Error al guardar la respuesta. " + error.message, "error");
    } finally {
      setDisabled(true);
    }
  };

  const handleRechazar = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      const cons = {
        anio,
        cuat,
        docente: user.dni,
      };
      await axios.post(`/api/docentes/rechazar/${anio}/${cuat}`, cons, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
    } catch (error) {
      console.error("Error al guardar la respuesta. " + error.message, "error");
    } finally {
      setDisabled(true);
    }
  };

  return (
    <>
      <PasosContainer />
      <div className="preparando-container">
        {!configsLoading && !loading && envio && (
          <>
            <h2>Preencuesta de horarios</h2>
            {conservar ? (
              <>
                <p>Elegiste conservar tus horarios preasignados.</p>
                <strong>Horarios preasignados:</strong>
                <Tabla opciones={horarios} />
              </>
            ) : (
              <>
                <p>Elegiste rechazar tus horarios preasignados.</p>
                <p>
                  A la brevedad te pediremos que completes la encuesta habitual
                  de horarios.
                </p>
              </>
            )}
          </>
        )}
        {!configsLoading && !loading && horarios.length == 0 && (
          <>
            <h2>Encuesta en preparación</h2>
            <p>
              Estamos preparando la encuesta de horarios para el próximo
              cuatrimestre.
            </p>
          </>
        )}
        {!configsLoading && !loading && horarios.length > 0 && !envio && (
          <>
            <h2>Preencuesta de horarios</h2>
            <p>
              Tenés preasignados los siguientes horarios para el segundo
              cuatrimestre de 2026.
            </p>

            <strong>Horarios preasignados:</strong>
            <Tabla opciones={horarios} />

            <p>
              Por favor indicá si querés confirmar o rechazar estos horarios. En
              caso de rechazarlos, deberás completar la encuesta habitual de
              horarios.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                maxWidth: "500px",
              }}
            >
              <button
                className="btn"
                disabled={disabled}
                onClick={handleConservar}
              >
                Conservar
              </button>
              <button
                className="btn"
                disabled={disabled}
                onClick={handleRechazar}
              >
                Rechazar
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PreparandoEncuesta;
